import { useCurrencyOptional } from '#bv/lib/currency/CurrencyContext'
import { formatUsd } from '#bv/lib/price'

type Props = {
  usd: number
  className?: string
  style?: React.CSSProperties
  /** Show "USD" suffix when displaying converted currency */
  showCode?: boolean
  /** Prefix e.g. "From " */
  prefix?: string
}

export function DisplayPrice({ usd, className, style, showCode, prefix }: Props) {
  const ctx = useCurrencyOptional()
  if (!ctx) {
    return (
      <span className={className} style={style}>
        {prefix}
        ${formatUsd(usd)}
      </span>
    )
  }

  const info = ctx.price(usd)
  return (
    <span className={className} style={style}>
      {prefix}
      {info.formatted}
      {showCode && info.currency !== 'USD' ? (
        <span className="ml-1 text-[0.85em] font-medium opacity-70">{info.currency}</span>
      ) : null}
    </span>
  )
}
